/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentsButtonComponent } from './ComponentsButtonComponent'
export type SectionsCallToActionComponent = {
  id?: number
  __component?: string
  title?: string
  subTitle?: string
  buttons?: Array<ComponentsButtonComponent>
  style?: SectionsCallToActionComponent.style
}
export namespace SectionsCallToActionComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    WHITE = 'White',
  }
}
